module.exports = __webpack_public_path__ + "media/images/ibjjf/book-33c1c20ed9618ed78b6930b97acbee5b.jpg";